import queryString from 'qs';

// 2 months from current date
const getDefaultEndDate = () => {
  const date = new Date();
  date.setMonth(date.getMonth() + 2);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-01`;
};

const getAvailableBriefDatesRequest = (queryParams) => {
  const queries = {};

  if (queryParams?.isSpecialEvent) queries['isSpecialEvent'] = queryParams?.isSpecialEvent;
  if (queryParams?.hostIds) queries['hostIds'] = queryParams?.hostIds;
  if (queryParams?.brandId) queries['brandId'] = queryParams?.brandId?.value;
  queries['endDate'] = queryParams?.endDate ?? getDefaultEndDate();

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getAvailableBriefDatesRequest;
